
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPlaceholderDeviceStatic as ObiPlaceholderDeviceStaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-placeholder-device-static.js';
 
 
 

 
 export const ObiPlaceholderDeviceStatic = createComponent({
   react: React,
   tagName: 'obi-placeholder-device-static',
   elementClass: ObiPlaceholderDeviceStaticElement,
   events: {
     
   }
  });
 
 